var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendar01B445Eb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 22H17.7778C19.0033 22 20 21.0133 20 19.8V4.4C20 3.1867 19.0033 2.2 17.7778 2.2H15.5556V0H13.3333V2.2H6.66667V0H4.44444V2.2H2.22222C0.996667 2.2 0 3.1867 0 4.4V19.8C0 21.0133 0.996667 22 2.22222 22ZM2.22222 5.5H17.7778V7.7H2.22222V5.5Z",
    fill: "#B6E0F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar01B445Eb);
export default __webpack_public_path__ + "static/media/ic_calendar.01b445eb.01b445eb30861114667f5c9568f24f34.svg";
export { ForwardRef as ReactComponent };